export var ValidationDisplayMode;
(function (ValidationDisplayMode) {
    /** errors will display immediately if the properties are not valid. */
    ValidationDisplayMode[ValidationDisplayMode["Always"] = 1] = "Always";
    /** errors will only display after the element loses focus. */
    ValidationDisplayMode[ValidationDisplayMode["AfterBlur"] = 2] = "AfterBlur";
    /** errors will only be displayed once forceShowErrors is set to true on the model. */
    ValidationDisplayMode[ValidationDisplayMode["AfterSubmit"] = 3] = "AfterSubmit";
    /** errors will not be shown. */
    ValidationDisplayMode[ValidationDisplayMode["Never"] = 4] = "Never";
})(ValidationDisplayMode || (ValidationDisplayMode = {}));
